import React, { useState } from "react";
import {
  Button,
  TextField,
  Grid,
  FormControlLabel,
  Switch,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { Field } from "formik";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

/**
 * Seccion de credenciales / identidad de la conexion (name, token, status, isDefault).
 * SOLO para providers no-oficiales (Baileys / Evolution). La conexion oficial de Meta
 * (WABA) tiene su propio modal dedicado (WhatsAppOficialModal), ver 0362 §10.
 */
const ProviderCredentialsSection = ({ classes, values }) => {
  // El token guardado no viaja con la conexión (doc 0431, A-10): se pide aparte, con
  // permiso de editar conexiones y quedando en Seguridad (doc 0434, M12). Va a un recuadro
  // de solo lectura, no al campo: escribir en el campo es regenerarlo al guardar.
  const [tokenVisible, setTokenVisible] = useState(null);
  const [cargandoToken, setCargandoToken] = useState(false);

  const mostrarToken = async () => {
    setCargandoToken(true);
    try {
      const { data } = await api.get(`/whatsapp/${values.id}/token`);
      setTokenVisible(data?.token || "");
    } catch (err) {
      toastError(err);
    } finally {
      setCargandoToken(false);
    }
  };

  const copiarToken = async () => {
    try {
      await navigator.clipboard.writeText(tokenVisible);
      toast.success(i18n.t("whatsappModal.tokenCopied"));
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <>
                      {/* Nombre + Token en la misma fila */}
                      <Grid item xs={12} sm={6}>
                        <Field name="name">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label={i18n.t("whatsappModal.form.name")}
                              autoFocus
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              required
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              onChange={field.onChange}
                              InputProps={{
                                style: { fontSize: '0.875rem', height: '40px' }
                              }}
                              InputLabelProps={{
                                style: { fontSize: '0.875rem' }
                              }}
                              FormHelperTextProps={{
                                style: { fontSize: '0.75rem', marginTop: '4px' }
                              }}
                            />
                          )}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field name="token">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Token (Opcional)"
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              className={classes.textFieldCompact}
                              placeholder={values?.tokenPreview ? i18n.t("whatsappModal.tokenKeepPlaceholder") : undefined}
                              helperText={values?.tokenPreview ? i18n.t("whatsappModal.tokenSaved", { preview: values.tokenPreview }) : undefined}
                              value={field.value || ''}
                              onChange={field.onChange}
                              onBlur={field.onBlur}
                            />
                          )}
                        </Field>
                        {values?.id && values?.tokenPreview && tokenVisible === null && (
                          <Button size="small" color="primary" onClick={mostrarToken} disabled={cargandoToken}>
                            {i18n.t("whatsappModal.tokenReveal")}
                          </Button>
                        )}
                        {tokenVisible !== null && (
                          <TextField
                            label={i18n.t("whatsappModal.tokenCurrent")}
                            value={tokenVisible}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <Button size="small" color="primary" onClick={copiarToken}>
                                  {i18n.t("whatsappModal.tokenCopy")}
                                </Button>
                              )
                            }}
                          />
                        )}
                      </Grid>

                      {/* Status + Por defecto en la misma fila */}
                      <Grid item xs={12} sm={6}>
                        <FormControl variant="outlined" margin="dense" fullWidth className={classes.formControlCompact}>
                          <InputLabel style={{ fontSize: '0.875rem' }}>Status</InputLabel>
                          <Field
                            as={Select}
                            name="status"
                            label="Status"
                            required
                          >
                            <MenuItem value="OPENING" style={{ fontSize: '0.875rem', minHeight: '36px', padding: '6px 12px' }}>Abriendo</MenuItem>
                            <MenuItem value="CONNECTED" style={{ fontSize: '0.875rem', minHeight: '36px', padding: '6px 12px' }}>Conectado</MenuItem>
                            <MenuItem value="DISCONNECTED" style={{ fontSize: '0.875rem', minHeight: '36px', padding: '6px 12px' }}>Desconectado</MenuItem>
                          </Field>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControlLabel
                          control={
                            <Field
                              as={Switch}
                              color="primary"
                              name="isDefault"
                              checked={values.isDefault}
                            />
                          }
                          label={i18n.t("whatsappModal.form.default")}
                        />
                      </Grid>
    </>
  );
};

export default ProviderCredentialsSection;
